import { ConsoleAppender } from "./ConsoleAppender";
/**
 * A console appender implementation to log to the Node Console. This will only work with Node JS.
 * @class
 */
export class NodeConsoleAppender extends ConsoleAppender {
    /**
     * Initializes a new instance of the `NodeConsoleAppender` class.
     * @constructor
     * @param logLevel {LogLevel} Logging level or threshold.
     */
    constructor(logLevel) {
        super(logLevel, global.console);
    }
    /**
     * Returns a string representation of the appender.
     * @method
     * @return {string} The string representation of the appender.
     */
    toString() {
        return "NodeConsoleAppender";
    }
}
//# sourceMappingURL=NodeConsoleAppender.js.map